import {
    styled,
    Container as MuiContainer,
    Pagination as MuiPagination,
} from "@mui/material";

export const CardContainer = styled(MuiContainer)((theme) => {
    return {
        height: "620px",
        padding: "2rem 0",
    };
});

export const Pagination = styled(MuiPagination)(({ theme }) => {
    return {
        paddingTop: "1.5rem",
        justifyContent: "center",
        display: "flex",
        ".MuiPaginationItem-root.Mui-selected": {
            backgroundColor: theme.palette.grey[600],
            color: theme.palette.primary.main,
        },
    };
});
